import { SizeXsIcon } from './SizeXsIcon';

/**
 * author: Austin Andrews
 * id D0173A61-33D3-43A2-8DB3-2E95EEEF7D7E
 * name size-xs
 * version: 5.0.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/size-xs.svg
 * tags
 */
export const SizeExtraSmallIcon = SizeXsIcon;
export default SizeExtraSmallIcon